export enum LiabilitiesDelegateSelectOptionType {
  LIABILITY = 'LIABILITY',
  BILLER = 'BILLER',
  SUBACCOUNT = 'SUBACCOUNT',
}
